<template>
	<div class="overlay-scene-thumb" :style="{ aspectRatio: `${overlay.width} / ${overlay.height}` }">
		<img v-if="scene.thumbnail" :src="scene.thumbnail" draggable="false" />
	</div>
</template>

<script>
// Shows the scene's stored preview image, scaled to the width of the scenes column; the editor re-renders and saves
// the image now and then.
export default {
	props: {
		overlay: { type: Object, required: true },
		scene: { type: Object, required: true },
	},
};
</script>

<style scoped>
.overlay-scene-thumb {
	position: relative;
	width: 100%;
	background: repeating-conic-gradient(#4a4a60 0% 25%, #383850 0% 50%) 0 0 / 12px 12px;
	overflow: hidden;
	pointer-events: none;
}

img {
	display: block;
	width: 100%;
	height: 100%;
}
</style>
